import { IExtraOptionPrototype } from "infrastructure/interfaces/IExtraMenuOption";
import { IModalService } from "angular-ui-bootstrap";
import baseTariffModalTemplate from "application/osago/components/ugsk-osago-base-tariff-modal/ugsk-osago-base-tariff-modal.html";
import { BaseTariffModal } from "application/osago/components/ugsk-osago-base-tariff-modal/ugsk-osago-base-tariff-modal";

export default {
    action(context) {
        const $uibModal = context.di<IModalService>("$uibModal");

        $uibModal
            .open({
                controller: BaseTariffModal,
                controllerAs: "vm",
                resolve: {
                    context,
                },
                size: "lg",
                template: baseTariffModalTemplate,
            });
    },
    icon: "fa-gear",
    title: "Настроить тариф",
} as IExtraOptionPrototype;
